/**
 * The brand's terms and conditions and privacy policy live in the engine (Legales in the admin).
 * Every app and web opens them with the same link, `<engine>/legal/<brand>/<terms|privacy>`, and the
 * engine renders the published text or redirects to the client's own page, so changing them never
 * needs a new deploy. Web port of rog-master-app/src/utils/legal.js.
 */
export const LEGAL_TYPES = { terms: 'terms', privacy: 'privacy' };

/** `REACT_APP_API_URL` is the engine's root (`.../v1`), where the public legal pages hang. */
export const buildLegalUrl = (apiUrl, brand, type) =>
  `${String(apiUrl || '').replace(/\/+$/, '')}/legal/${encodeURIComponent(
    brand || '',
  )}/${type}`;

export const legalUrl = type =>
  buildLegalUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_BRAND, type);
